import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@olxeu-jobs/ui';
import { useState } from 'react';
import { FormattedMessage } from '~i18n';

type ActionClick = (params: { setLoading: React.Dispatch<React.SetStateAction<boolean>> }) => void;

type Props = Omit<React.ComponentPropsWithoutRef<typeof Modal>, 'closeable'> & {
  header?: React.ReactNode;
  children?: React.ReactNode;
  positiveLabel?: React.ReactNode;
  negativeLabel?: React.ReactNode;
  onPositiveClick: ActionClick;
  onNegativeClick: ActionClick;
};

export const PromptModal: React.FC<Props> = ({
  children,
  header,
  positiveLabel,
  negativeLabel,
  onPositiveClick,
  onNegativeClick,
  ...modalProps
}) => {
  const [positiveLoading, setPositiveLoading] = useState(false);
  const [negativeLoading, setNegativeLoading] = useState(false);

  return (
    <Modal {...modalProps} closeable={false}>
      {header && <ModalHeader>{header}</ModalHeader>}
      {children && <ModalBody>{children}</ModalBody>}
      <ModalFooter $style={({ $theme }) => ({ gap: $theme.space[32] })}>
        <Button
          kind="tertiary"
          isLoading={negativeLoading}
          disabled={negativeLoading || positiveLoading}
          onClick={() => {
            onNegativeClick({ setLoading: setNegativeLoading });
          }}
        >
          {negativeLabel || <FormattedMessage id="comp.button.no" defaultMessage="No" />}
        </Button>
        <Button
          isLoading={positiveLoading}
          disabled={positiveLoading || negativeLoading}
          onClick={() => {
            onPositiveClick({ setLoading: setPositiveLoading });
          }}
        >
          {positiveLabel || <FormattedMessage id="comp.button.yes" defaultMessage="Yes" />}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
